"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickDimensionsService = void 0;
class ClickDimensionsService {
    static init(config) {
        ClickDimensionsService.instance = new ClickDimensionsService(config);
    }
    static submitForm() {
        ClickDimensionsService.instance.submitForm();
    }
    constructor(config) {
        this.debug = false;
        this.fieldMapping = new Map();
        this._beforeSubmit = () => { };
        this._afterSubmit = () => { };
        this._onError = () => { };
        this._beforeSubmit = config.beforeSubmit;
        this._afterSubmit = config.afterSubmit;
        this._onError = config.onError;
        this.debug = config.debug;
        this.customForm = document.getElementById(config.formId);
        const submittedData = this.loadSubmittedData();
        if (submittedData) {
            this.afterSubmit(submittedData);
        }
        else {
            this.loadClickDimensions(config.cdPageId);
        }
    }
    loadSubmittedData() {
        const params = new URLSearchParams(window.location.search);
        const hasSubmitted = !!params.get("cdcomplete");
        if (!hasSubmitted) {
            return null;
        }
        const storedData = localStorage.getItem("dsgcd");
        if (!storedData) {
            return null;
        }
        try {
            const storedValues = JSON.parse(storedData);
            this.afterSubmit(storedValues);
        }
        catch (e) {
            return null;
        }
    }
    loadClickDimensions(cdPageId) {
        window["loc"] = "https://web.descartes.com/descartescom-agoyy/pages/";
        const cdDiv = document.createElement("div");
        cdDiv.setAttribute("pageID", cdPageId);
        if (!this.debug) {
            cdDiv.style.display = "none";
        }
        this.customForm.after(cdDiv);
        this.cdDiv = cdDiv;
        return new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://cdn-eu.clickdimensions.com/web/v10/CDWidget.js";
            script.async = true;
            script.onload = () => {
                this.watchForFormLoad();
                resolve();
            };
            script.onerror = () => {
                reject();
            };
            document.head.appendChild(script);
        });
    }
    getFormData() {
        const formData = new FormData(this.customForm);
        const values = {};
        formData.forEach((value, key) => {
            values[key] = value;
        });
        return values;
    }
    validateForm() {
        // Clear existing errors
        this.customForm
            .querySelectorAll("[data-error]")
            .forEach((field) => {
            field.removeAttribute("data-error");
            field.classList.remove("error");
        });
        if (!window["FormValid"]) {
            return null;
        }
        // Run validation
        const valid = window["FormValid"]();
        if (valid) {
            return null;
        }
        const errors = {};
        this.fieldMapping.forEach((cdInput, customField) => {
            const errorInfo = document.getElementById(`required_info_${cdInput.id}`);
            if (!errorInfo) {
                return;
            }
            const errorText = errorInfo.innerText.trim();
            if (errorText) {
                customField.setAttribute("data-error", errorText);
                customField.classList.add("error");
                errors[customField.name] = errorText;
            }
        });
        if (Object.keys(errors).length) {
            return errors;
        }
        else {
            return null;
        }
    }
    submitForm() {
        const errors = this.validateForm();
        if (errors) {
            console.error("Form validation failed", errors);
            this.onError(errors);
            return;
        }
        this.beforeSubmit();
        // Simulate a submit click
        const cdForm = this.cdDiv.querySelector("form");
        const submitButton = cdForm.querySelector("#btnSubmit");
        window["SendForm"](submitButton, "clickdimensionsForm", "Form");
    }
    watchForFormLoad() {
        const interval = setInterval(() => {
            const form = this.cdDiv.querySelector("form");
            if (form) {
                clearInterval(interval);
                this.setupForms();
            }
        }, 100);
    }
    setupForms() {
        const cdForm = this.cdDiv.querySelector("form");
        // Add custom form fields to the CD form
        this.customForm
            .querySelectorAll("[data-cdid]")
            .forEach((customField) => {
            const cdFieldName = customField.getAttribute("data-cdid");
            let cdInput = cdForm.querySelector(`[contactfield="${cdFieldName}"]`);
            if (!cdInput) {
                cdInput = cdForm.querySelector(`[id="${cdFieldName}"]`);
            }
            if (!cdInput) {
                console.error(`Could not find CDForm for key ${cdFieldName} mapped to field ${customField.name}`);
                return;
            }
            this.fieldMapping.set(customField, cdInput);
        });
        this.customForm.addEventListener("input", (e) => {
            this.fieldMapping.forEach((cdInput, customField) => {
                if (cdInput.type === "checkbox") {
                    cdInput.checked = customField.checked;
                }
                else {
                    cdInput.value = customField.value ?? "";
                }
            });
        });
        this.customForm.addEventListener("submit", (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.submitForm();
        });
    }
    onError(errors) {
        if (this._onError) {
            this._onError(errors);
        }
    }
    beforeSubmit() {
        const formData = this.getFormData();
        if (localStorage) {
            localStorage.setItem("dsgcd", JSON.stringify(formData));
        }
        if (this._beforeSubmit) {
            this._beforeSubmit(formData);
        }
    }
    afterSubmit(data) {
        Object.keys(data).forEach((key) => {
            const field = this.customForm.querySelector(`[name="${key}"]`);
            if (field) {
                field.value = data[key];
            }
        });
        if (this._afterSubmit) {
            this._afterSubmit(data);
        }
    }
}
exports.ClickDimensionsService = ClickDimensionsService;
